/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MokushiinspectionNado {

    /**
     * メーター外観異常フラグ
     */
    meterExteriorAbnormalflag?: string;
    /**
     * メーターガス栓異常フラグ
     */
    meterGassenAbnormalflag?: string;
    /**
     * マイコンメーターテスト遮断異常フラグ
     */
    microcontrollermeterTestblockAbnormalflag?: string;
    /**
     * マイコンメーター復帰異常フラグ
     */
    microcontrollermeterReturnAbnormalflag?: string;
    /**
     * 動止確認漏洩検査可否フラグ
     */
    operationcheckLeaktestKahiflg?: string;
    /**
     * メーター指針動止確認コード
     */
    meterShishinstartandstopConfirmationcode?: string;
    /**
     * メーター指針動止確認コード名称
     */
    metershishinOperationcheckCodeaname?: string;
    /**
     * 漏洩検査・圧力
     */
    leaktestAtrk?: number;
    /**
     * 漏洩検査・時間
     */
    leaktestTime?: number;
    /**
     * 漏洩検査・確認結果フラグ
     */
    leaktestConfirmationresultFlg?: string;
}

